import React, { Component } from 'react';
import Header from './Layout/Header';
import ShotBySeat from './SeatCommon/ShotBySeat';
import { connect } from 'react-redux';
import { SeatData, CheckLoader } from '../Redux/action/seatAction';
import SeatTable from './SeatCommon/SeatTable';
import FilterSeat from './SeatCommon/FilterSeat';
import { CSVLink } from 'react-csv';
import { dataUser, logoutHandler } from './Helpers/util';
import { Navigate } from 'react-router-dom';
import MarketingPanel from '../Component/MarketingPanel';
import { getServiceAccess } from '../Redux/action/userActions';
import Sidebar from "../Component/Layout/Sidebar";
import CustomHeader from "../Component/Layout/Header";
import { Layout } from "antd";
import SwInput from './Common/FormComponent/SwInput';
import SwKpi from './Common/SwKPI/SwKPI';
import SwKpiGroup from './Common/SwKPI/SwKpiGroup';
import SwLoader from './Common/SwLoader/SwLoader';

const userDataLocal = dataUser();
var UserObj = JSON.parse(userDataLocal);

class SeatManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      getData: {
        name: 'my-map',
        areas: [],
      },
      seatListData: [],
      collapsed: true,
      ListRow: '',
      SortData: '',
      company_id: UserObj ? UserObj.company_id : null,
      row: '25',
      filterData: {},
      pgno: 1,
      isSearchVisible: false,
      searchText: '',
      status: '',
      selectedKpi: 'total',
      accessServiceLists: [],
      loaderServiceAccess: true,
      userRole: UserObj && UserObj.role_data ? UserObj.role_data : [],
    };
    this.forwordPage = this.forwordPage.bind(this);
    this.pageBackword = this.pageBackword.bind(this);
  }

  toggleSearchHandler = () => {
    const isVisible = this.state.isSearchVisible;
    this.setState({
      isSearchVisible: !isVisible,
    });
  };


  toggleCollapsed = () => {
    this.setState((prevState) => ({ collapsed: !prevState.collapsed }));
  };

  shortSelectData = shortallkey => {
    this.setState({
      SortData: shortallkey,
    });
  };

  handleLanguage = langValue => {
    this.setState({
      filterData: langValue,
    });
  };

  setPage = e => {
    this.setState({
      pgno: 1,
      row: 25,
    });
  };

  forwordPage(e) {
    this.setState({
      pgno: this.state.pgno + 1,
    });
    let parms = {
      order: this.state.SortData,
      ...this.state.filterData,
      company_id: this.state.company_id,
      // status: this.state.status,
      pgno: this.state.pgno + 1,
      row: this.state.row,
      search: this.state.searchText,
    };
    this.props.CheckLoader();
    if (!UserObj?.company_id) {
      logoutHandler()
    }
    this.props.SeatData(parms);
  }

  pageBackword() {
    this.setState({
      pgno: this.state.pgno - 1,
    });
    let parms = {
      order: this.state.SortData,
      ...this.state.filterData,
      pgno: this.state.pgno - 1,
      row: this.state.row,
      company_id: this.state.company_id,
      search: this.state.searchText,
    };
    this.props.CheckLoader();
    if (!UserObj?.company_id) {
      logoutHandler()
    }
    this.props.SeatData(parms);
  }

  selectRows = e => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    const params = {
      ...this.state.filterData,
      order: this.state.SortData,
      pgno: this.state.pgno,
      row: e.target.value,
      company_id: this.state.company_id,
    };
    this.props.CheckLoader();
    if (!UserObj?.company_id) {
      logoutHandler()
    }
    this.props.SeatData(params);
  };

  setuserlist = () => {
    const params = {
      pgno: this.state.pgno,
      row: this.state.row,
      company_id: this.state.company_id,
    };
    if (!UserObj?.company_id) {
      logoutHandler()
    }
    this.props.SeatData(params);
  };

  changeFilterData = event => {
    this.setState({ searchText: event.target.value }, () => {
      let params = {
        pgno: this.state.pgno,
        row: this.state.row,
        company_id: this.state.company_id,
        search: this.state.searchText,
      };
      this.props.CheckLoader();
      if (!UserObj?.company_id) {
        logoutHandler()
      }
      this.props.SeatData(params);
    });
  };

  clearSearchBox = () => {
    this.setState({ searchText: '' });
  };

  componentDidMount() {
    this.setuserlist();
  }

  componentWillMount() {
    this.fetchServiceAccess();
  }

  fetchServiceAccess = async () => {
    const getCompanyId = UserObj.company_id;
    const response = await getServiceAccess(getCompanyId);
    this.setState({ accessServiceLists: response, loaderServiceAccess: false });
  }

  handleStatus = status => {
    this.setState({ status: status }, () => {
      const params = {
        company_id: this.state.company_id,
        status: this.state.status,
        row: this.state.row,
        pgno: this.state.pgno,
      };
      this.props.CheckLoader();
      if (!UserObj?.company_id) {
        logoutHandler()
      }
      this.props.SeatData(params, 'action');
    });
  };

  handleSeatType(seattype) {
    const params = {
      company_id: this.state.company_id,
      seattype: seattype,
      row: this.state.row,
      pgno: this.state.pgno,
    };
    this.props.CheckLoader();
    if (!UserObj?.company_id) {
      logoutHandler()
    }
    this.props.SeatData(params, 'action');
  }

  handleKpiClick = (key, action) => {
    const { selectedKpi } = this.state;
    if (selectedKpi === key) {
      this.setState({ selectedKpi: '' });
      this.handleStatus();
    } else {
      this.setState({ selectedKpi: key });
      action();
    }
  };

  componentWillReceiveProps(props) {
    if (props.seatReducer && props.seatReducer.status == 200) {
      this.setState({
        ListRow: props.seatReducer.data && props.seatReducer.data.rows,
        seatListData: props.seatReducer && props.seatReducer.data,
      });
    }
  }

  render() {
    const SeatManagement = this.state.userRole.find(
      element =>
        element.service_id == '2' &&
        (element.role_for_read === '1' || element.role_for_write === '1'),
    );
    if (!SeatManagement) {
      return <Navigate to="/Dashboard" />;
    }

    const Loader = this.props.setLoader.loader;
    let serviceAccess = true;
    const serviceAccessId = 2;
    if (this.state.accessServiceLists.length > 0) {
      let serviceAccessobject = {};
      this.state.accessServiceLists.map(e => {
        if (e.id == serviceAccessId) serviceAccessobject = e;
      });
      serviceAccess = false;
      if (serviceAccessobject)
        serviceAccess = serviceAccessobject.service_access;
    }

    return (
      <>
        <Layout>

          <Sidebar collapsed={this.state.collapsed} />

          <CustomHeader collapsed={this.state.collapsed} toggleCollapsed={this.toggleCollapsed} />


          <Layout className={this.state.collapsed ? 'PageLayout CollapsedPageLayout' : 'PageLayout'}>
            {serviceAccess === true ?
              <>
                <div className="PageContent">
                  <div className="row">
                    <div className="col-md-6 col-lg-6">
                      <div className='SwHeading'>
                        <h2 className='mb-0'>Manage Seats</h2>
                      </div>
                    </div>

                    <div className="col-md-6 col-lg-6">
                      <div className="PageHead_Optons_Row">
                        <ul className='PageHead_Optons_RightAligned'>
                          <li>
                            <div className="SwInputWithIcon">
                              <SwInput
                                placeholder="Search..."
                                value={this.state.searchText}
                                onChange={this.changeFilterData}
                              />
                              <span className="SwInputicon">
                                <i className="bi bi-search"></i>
                              </span>
                            </div>
                          </li>
                          <li>
                            <FilterSeat
                              clearSearch={this.clearSearchBox}
                              frow={this.state.row}
                              page={this.state.pgno}
                              onSelectLanguage={this.handleLanguage}
                            />
                          </li>
                          <li>
                            <ShotBySeat
                              page={this.setPage}
                              spage={this.state.pgno}
                              srow={this.state.row}
                              changeshort={this.shortSelectData}
                            />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <SwKpiGroup>
                        <SwKpi
                          label="Total Seats"
                          value={this.state.seatListData && this.state.seatListData.total}
                          active={this.state.selectedKpi === 'total'}
                          tooltip="Filter is applied in Total Seats."
                          onClick={() => this.handleKpiClick('total', () => this.handleStatus())}
                        />
                        <SwKpi
                          label="Occupied Seats"
                          value={this.state.seatListData && this.state.seatListData.occupied}
                          active={this.state.selectedKpi === 'occupied'}
                          tooltip="Filter is applied in Occupied Seats."
                          onClick={() => this.handleKpiClick('occupied', () => this.handleStatus(1))}
                        />
                        <SwKpi
                          label="Vacant Seats"
                          value={this.state.seatListData && this.state.seatListData.vacant}
                          active={this.state.selectedKpi === 'vacant'}
                          tooltip="Filter is applied in Vacant Seats."
                          onClick={() => this.handleKpiClick('vacant', () => this.handleStatus(0))}
                        />
                        <SwKpi
                          label="Fixed Seats"
                          value={this.state.seatListData && this.state.seatListData.fixed}
                          active={this.state.selectedKpi === 'fixed'}
                          tooltip="Filter is applied in Fixed Seats."
                          onClick={() => this.handleKpiClick('fixed', () => this.handleSeatType(1))}
                        />
                        <SwKpi
                          label="Flexi Seats"
                          value={this.state.seatListData && this.state.seatListData.flexi}
                          active={this.state.selectedKpi === 'flexi'}
                          tooltip="Filter is applied in Flexi Seats."
                          onClick={() => this.handleKpiClick('flexi', () => this.handleSeatType(2))}
                        />
                      </SwKpiGroup>

                      <div className="mt-2">

                        <SeatTable
                          passCodinates={this.state.getData}
                          seatPg={this.state.pgno}
                          seatRow={this.state.row}
                          onPageChange={(page, pageSize) => {
                            this.setState({
                              pgno: page,
                              row: String(pageSize),
                            });
                            const parms = {
                              order: this.state.SortData,
                              ...this.state.filterData,
                              company_id: this.state.company_id,
                              pgno: page,
                              row: pageSize,
                              search: this.state.searchText,
                            };
                            this.props.CheckLoader();
                            if (!UserObj?.company_id) {
                              logoutHandler()
                            }
                            this.props.SeatData(parms);
                          }}
                        />

                      </div>

                    </div>
                  </div>
                </div>
              </>
              : this.state.loaderServiceAccess == true ? (

                <>

                  <SwLoader />

                </>

              ) : <MarketingPanel />

            }

          </Layout>

        </Layout>
      </>
    );
  }
}

const mapStateToProps = state => ({
  seatReducer: state.seatReducer.SeatList,
  setLoader: state.seatReducer,
});

const mapActionsToProps = {
  SeatData,
  CheckLoader,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(SeatManagement);
